import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AccountBlockGuard } from '../account/guard/account-block-guard';
import { PermissionGuard } from '../shared/guards/permission-guard';
import { VersionGuard } from '../shared/guards/version-guard';

import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { PermissionLevel } from '../shared/permission/permission';
import { RoutePaths } from '../shared/navigation/route-paths';
import { LsAccountingSetupComponent } from './ls-accounting-setup/ls-accounting-setup.component';

const lsAccountingRoutes: Array<DynamicRoute> = [
  {
    path: RoutePaths.EMPTY,
    component: LsAccountingSetupComponent,
    canActivate: [VersionGuard, PermissionGuard, AccountBlockGuard],
    data: {
      permissionLevel: PermissionLevel.MANAGER
    }
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(lsAccountingRoutes)]
})
export class LsAccountingRoutingModule {}
